import React from "react";

function ArticleDetail() {
  return (
    <div className="py-10">
      <img src="/pic2.jpg" className="w-full h-80" />
      <div className="text-3xl font-bold mb-5 py-5">Agriculture news</div>
      <p className="mb-5 px-5">
        A modern JavaScript charting library that allows you to build
        interactive data visualizations with simple API and 100+ ready-to-use
        samples. Packed with the features that you expect, ApexCharts includes
        over a dozen chart types that deliver beautiful, responsive
        visualizations in your apps and dashboards. ApexCharts is an
        MIT-licensed open-source project that can be used in commercial and
        non-commercial projects.
      </p>
      <p className="mb-5 px-5">
        A modern JavaScript charting library that allows you to build
        interactive data visualizations with simple API and 100+ ready-to-use
        samples. Packed with the features that you expect, ApexCharts includes
        over a dozen chart types that deliver beautiful, responsive
        visualizations in your apps and dashboards. ApexCharts is an
        MIT-licensed open-source project that can be used in commercial and
        non-commercial projects.
      </p>
      <p className="mb-5 px-5">
        A modern JavaScript charting library that allows you to build
        interactive data visualizations with simple API and 100+ ready-to-use
        samples. Packed with the features that you expect, ApexCharts includes
        over a dozen chart types that deliver beautiful, responsive
        visualizations in your apps and dashboards. ApexCharts is an
        MIT-licensed open-source project that can be used in commercial and
        non-commercial projects.
      </p>
      <p className="mb-5 px-5">
        A modern JavaScript charting library that allows you to build
        interactive data visualizations with simple API and 100+ ready-to-use
        samples. Packed with the features that you expect, ApexCharts includes
        over a dozen chart types that deliver beautiful, responsive
        visualizations in your apps and dashboards. ApexCharts is an
        MIT-licensed open-source project that can be used in commercial and
        non-commercial projects.
      </p>
    </div>
  );
}

export default ArticleDetail;
